import { useEffect, useState } from "react"
import { fetchLastedProducts } from "../../api/Product";
import { API_URL } from "env";


interface Product {
    id: number
    slug: string
    name: string
    unit: string
    image: string
    price: number
    promoPrice?: number
    discount?: string
    sold: number
    seller: string
    sellerLogo: string
    quantity: number
    liked: boolean
    bg: boolean
}

interface ProductItemProps {
    data: Product;
    onMinus: () => void;
    onPlus: () => void;
    onToggleLike: () => void;
}

export default function ProductList({ topic }: { topic?: string }) {
    const [list, setList] = useState<Product[]>([])

    useEffect(() => {
        if (topic === "latest") {
            fetchLastedProducts({ limit: 10, page: 1 }).then(res => {
                if (res.status && res.data.items) {
                    const mapped: Product[] = res.data.items.map((item: any) => {
                        const discountPercent = item.discount || 0;
                        const hasDiscount = discountPercent > 0;
                        const finalPrice = item.price;

                        return {
                            id: item.id,
                            slug: item.slug,
                            name: item.name,
                            unit: item.short_content || "Hộp",
                            image: item.avatar ? (item.avatar.startsWith('http') ? item.avatar : `${API_URL}/${item.avatar}`) : "",
                            price: finalPrice,
                            promoPrice: hasDiscount ? Math.round(item.price / (1 - discountPercent / 100)) : undefined,
                            discount: hasDiscount ? `-${discountPercent}%` : undefined,
                            sold: item.position || 0,
                            seller: "Dược Tâm Anh",
                            sellerLogo: "https://cdn-web-next.thuocsi.vn/icons/color_seller.svg",
                            quantity: 0,
                            liked: false,
                            bg: false,
                        }
                    });
                    setList(mapped);
                }
            });
        }
    }, [topic]);

    const updateQty = (id: number, delta: number): void => {
        setList((prev: Product[]) =>
            prev.map((item: Product) =>
                item.id === id
                    ? {
                        ...item,
                        quantity: Math.max(0, Math.min(item.quantity + delta, 5)),
                    }
                    : item
            )
        )
    }

    const toggleLike = (id: number): void => {
        setList((prev: Product[]) =>
            prev.map((item: Product) =>
                item.id === id ? { ...item, liked: !item.liked } : item
            )
        )
    }

    return (
        <div className="style_gridProductRandom__kZRVj">
            {list.map(item => (
                <ProductItem
                    key={item.id}
                    data={item}
                    onMinus={() => updateQty(item.id, -1)}
                    onPlus={() => updateQty(item.id, 1)}
                    onToggleLike={() => toggleLike(item.id)}
                />
            ))}
        </div>
    )
}


function ProductItem({ data, onMinus, onPlus, onToggleLike }: ProductItemProps) {
    return (
        <div
            className={`styles_container__IDdis ${data.bg ? "t-bg-color" : "t-bg-white"}`}
            role="button"
            tabIndex={0}
        >
            {data.discount && (
                <p className="MuiTypography-root styles_promo__losWR MuiTypography-body1">
                    {data.discount}
                </p>
            )}

            <div className="styles_tooltipRight__KgBN7" role="button">
                <div
                    className="styles_customButton__HNiJK"
                    title="Đánh dấu sản phẩm quan tâm"
                    onClick={onToggleLike}
                >
                    <svg style={{
                        fontSize: 24,
                        color: data.liked
                            ? "rgb(234, 32, 43)"
                            : "rgba(0, 0, 0, 0.2)",
                    }} className="MuiSvgIcon-root styles_icon__Zwjan" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path></svg>
                </div>
            </div>

            {/* === TOP IMAGE (GIỮ NGUYÊN) === */}

            {/* ================= TOP IMAGE ================= */}
            <div className="styles_topContainer__8eSB4">
                <a
                    className="styles_mobile_rootBase__8z7PQ styles_stylesImage__YoHx0"
                    href={`/product/${data.slug}`}
                >
                    <span
                        style={{
                            boxSizing: "border-box",
                            display: "inline-block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "relative",
                            maxWidth: "100%",
                        }}
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                maxWidth: "100%",
                            }}
                        >
                            <img
                                alt=""
                                aria-hidden="true"
                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27160%27%20height=%27160%27/%3e"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </span>

                        <img
                            alt={data.name}
                            src={`${data.image}?width=300&quality=80`}
                            decoding="async"
                            data-nimg="intrinsic"
                            className="styles_image__Y8Jva"
                            style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                padding: 0,
                                border: "none",
                                margin: "auto",
                                display: "block",
                                width: 0,
                                height: 0,
                                minWidth: "100%",
                                maxWidth: "100%",
                                minHeight: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                        <noscript />
                    </span>
                </a>

                {/* ================= TAG LIST ================= */}
                <div className="styles_listTag__QSJO1">
                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/tag/khan-hang"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="https://gcs.buymed.com/thuocsi-live/internal/cms/20244fdf8c496cd067b6c60fa85b18ddKHAN_HÀNG_Tag_Label__CARD_DOC.svg"
                                src="https://gcs.buymed.com/thuocsi-live/internal/cms/20244fdf8c496cd067b6c60fa85b18ddKHAN_HÀNG_Tag_Label__CARD_DOC.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/deals"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="https://gcs.buymed.com/thuocsi-live/internal/cms/20246deafec288500e6d1bc960592902khuyenmai_1.svg"
                                src="https://gcs.buymed.com/thuocsi-live/internal/cms/20246deafec288500e6d1bc960592902khuyenmai_1.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/products"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="https://gcs.buymed.com/thuocsi-live/internal/cms/2025a4113564593510c14c1f6ad7ec84limited_doc.svg"
                                src="https://gcs.buymed.com/thuocsi-live/internal/cms/2025a4113564593510c14c1f6ad7ec84limited_doc.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>
                </div>
            </div>

            {/* ================= UNDER CONTAINER ================= */}
            <div className="styles_underContainer__mL2nM">
                {/* PRICE */}
                <div className="styles_priceContainer__F_qQS px-[8px]">
                    <div className="styles_price__P5IMX" style={{ transform: "translateX(0px)" }}>
                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                            <div
                                className="styles_canvasPrice__vw932"
                                style={{ height: 25 }}
                            >{data.price.toLocaleString()} ₫</div>
                        </div>
                    </div>

                    {data.promoPrice && (
                        <div className="styles_pricePromo__JxTg_ ml-[8px]">
                            <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                <div
                                    className="styles_canvasPrice__vw932 text-[12px]"
                                    style={{ height: 15, textDecoration: "line-through" }}
                                >{data.promoPrice.toLocaleString()} ₫</div>
                            </div>
                        </div>
                    )}
                </div>

                {/* TITLE */}
                <div className="styles_titleContainer__WYihl">
                    <a
                        className="styles_titleWrapper__FvOnI"
                        href={`/product/${data.slug}`}
                    >
                        <span>{data.name}</span>
                    </a>
                    <p className="MuiTypography-root styles_countPerItem__OvDsy MuiTypography-body1">
                        {data.unit}
                    </p>
                </div>

                {/* SELLER */}
                <div className="styles_wrapperTooltip__MHPzJ" title="MEDX">
                    <div className="styles_wrapperImage__VTK_J">
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2714%27%20height=%2716%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="MEDX"
                                data-origin-url="https://cdn-web-next.thuocsi.vn/icons/color_seller.svg"
                                src="https://cdn-web-next.thuocsi.vn/icons/color_seller.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                }}
                            />
                            <noscript />
                        </span>
                    </div>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_link__jjTWc"
                        target="_blank"
                        href="/seller-products/cong-ty-tnhh-duoc-pham-medx"
                    >
                        MEDX
                    </a>
                </div>

                {/* PROGRESS */}
                <div className="styles_progressContainer__JrGkW">
                    <div className="styles_progressBuy__hItNv">
                        <div
                            className="MuiLinearProgress-root MuiLinearProgress-colorPrimary css-1hyif4h MuiLinearProgress-determinate"
                            role="progressbar"
                            aria-valuenow={16}
                            aria-valuemin={0}
                            aria-valuemax={100}
                        >
                            <div
                                className="MuiLinearProgress-bar MuiLinearProgress-barColorPrimary MuiLinearProgress-bar1Determinate"
                                style={{ transform: "translateX(-84%)" }}
                            />
                        </div>
                        <p className="MuiTypography-root styles_buyCount__qtYPa MuiTypography-body1">
                            Đã bán {data.sold}
                        </p>
                    </div>

                    <span className="styles_limitMessage__Iq3IG">
                        Đặt tối đa 5 sản phẩm
                    </span>
                </div>

                <div className="styles_controlQuantity__QWHZr" />
            </div>

            {/* === QUANTITY CONTROL === */}
            <div className="styles_maxWidth__zBhsQ">
                <div className="styles_container__zH79T styles_quantityControlContainer__djBwR qty-control-lite-wrapper">
                    <div
                        className="styles_minusContainerNew__RSUQE qty-control-lite-minus"
                        role="button"
                        onClick={onMinus}
                        style={{ opacity: data.quantity === 0 ? 0.3 : 1 }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M7 12H17"
                                stroke="#999999"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>

                    <div className="styles_groupInput__3rE3S qty-control-lite-input-group">
                        <div className="styles_cartIconContainer__j1a05">
                            <div className="styles_inputVisible__4CFxn">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        d="M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z"
                                        fill="#999999"
                                    />
                                    <path
                                        d="M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z"
                                        fill="#999999"
                                    />
                                    <path
                                        d="M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z"
                                        fill="#999999"
                                    />
                                </svg>
                            </div>

                            {/* ✅ SYNC ĐÚNG STATE */}
                            <span className="styles_currentValue__ZYyd_">
                                {data.quantity}
                            </span>
                        </div>

                        <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary styles_newCardInput__AYuYU qty-control-lite-input css-1f63zq5">
                            <input
                                type="number"
                                className="MuiInput-input MuiInputBase-input css-mnn31"
                                value={data.quantity}
                                readOnly
                            />
                        </div>
                    </div>

                    <div
                        className="styles_addContainerNew__GECz2 qty-control-lite-plus"
                        role="button"
                        onClick={onPlus}
                        style={{ opacity: data.quantity >= 5 ? 0.3 : 1 }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <path
                                d="M12 17V7"
                                stroke="#005c29"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <path
                                d="M7 12L17 12"
                                stroke="#005c29"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    )
}

